module.exports = __webpack_public_path__ + "static/media/close.95db5223.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/notifications/close.svg
// module id = 993
// module chunks = 0